import { useContext, useEffect, useMemo, useRef } from "react";
import { useApolloClient } from "@apollo/client";
import { AgGridReact } from "ag-grid-react";
import { ProjectContext } from "context/ProjectProvider";
import {
  buildScopeListPrintColumnDefs,
  type ScopeListPrintRow
} from "pages/design-scope-page/shared/scope-list-print-columns";
import AgGridPrintLayout from "./ag-grid-print-layout";
import type { DesignScopeLinkedScopePrintViewState } from "./model";

function DesignScopeLinkedScopePrintView({
  state
}: {
  state: DesignScopeLinkedScopePrintViewState;
}) {
  const gridRef = useRef<AgGridReact<ScopeListPrintRow>>(null);
  const { gqlClientForProject } = useContext(ProjectContext);
  const subscriptionGqlClient = useApolloClient();

  useEffect(() => {
    if (!state.pdfFileBaseName) return undefined;
    const previousTitle = document.title;
    document.title = state.pdfFileBaseName;
    return () => {
      document.title = previousTitle;
    };
  }, [state.pdfFileBaseName]);

  const rowData: ScopeListPrintRow[] = state.context?.rowData ?? [];
  const groupByBid = Boolean(state.groupByBid);
  const includeLodAndNote = state.includeLodAndNote !== false;

  const columnDefs = useMemo(
    () => buildScopeListPrintColumnDefs({ includeLodAndNote, groupByBid }),
    [groupByBid, includeLodAndNote]
  );

  return (
    <div data-testid="design-scope-linked-scope-print-view">
      <AgGridPrintLayout
        gridRef={gridRef}
        state={state}
        columnDefEntity={columnDefs}
        rowData={rowData}
        rowLoading={false}
        getRowId={(params: { data: ScopeListPrintRow }) => params.data.id}
        gqlClient={gqlClientForProject ?? subscriptionGqlClient}
      />
    </div>
  );
}

export default DesignScopeLinkedScopePrintView;
